"use client";
import {useNeoContext} from "@/context/neo/neo.context";
import {fmtTime} from "@/libs/helper";
import React from "react";
const initials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map(s => s[0]?.toUpperCase())
    .join("");

export const StudentDetails: React.FC<any> = ({students}) => {
  const {hwFeatures} = useNeoContext();
  return (
    <div className="rounded-md bg-[#F9FAFB] p-1">
      <h3 className="mb-1 text-lg font-semibold text-gray-900">User Details</h3>
      <ul className="-ml-1 h-[250px] space-y-1 overflow-y-auto scroll-smooth bg-transparent [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {students.map((s: any, i: number) => (
          <li
            key={i}
            className="flex items-center justify-between gap-1 rounded-xl p-1"
          >
            <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#FFC727]/20 p-4 text-sm font-semibold text-[#FFC727]">
              {initials(s.stuName)}
            </div>
            <div className="min-w-0 flex-1">
              <div
                className="truncate text-sm font-semibold text-gray-900"
                title={s.stuName}
              >
                {s.stuName}
              </div>
              {(hwFeatures as any)?.rfid && (
                <>
                  <div className="truncate text-[11px] text-green-700">
                    {s.startSwipe
                      ? `Pickup Time - ${fmtTime(s.startSwipe) ?? "N/A"}`
                      : "Pickup Time - N/A"}
                  </div>
                  <div className="text-[11px] text-green-700">
                    {s.endSwipe
                      ? `Drop Time - ${fmtTime(s.endSwipe) ?? "N/A"}`
                      : "Drop Time - N/A"}
                  </div>
                </>
              )}
            </div>
            <div className="shrink-0 rounded-md bg-green-100 px-3 py-1 text-[11px] font-semibold text-green-700">
              {s.className}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
